export const acceptedFileTypesForComponentUpload = '.tre,.ans,.tps,.tdltruss,.zip,.pdf';
